import { render, staticRenderFns } from "./cooperationPage.vue?vue&type=template&id=3a533a8d&scoped=true&"
import script from "./cooperationPage.vue?vue&type=script&lang=js&"
export * from "./cooperationPage.vue?vue&type=script&lang=js&"
import style0 from "./cooperationPage.vue?vue&type=style&index=0&id=3a533a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a533a8d",
  null
  
)

export default component.exports